(function () {

    // Init/handle sidebar triggers
    document.addEventListener('click', (e) => {
        const target = e.target;
        const sidebarTarget = target.dataset?.sidebar;

        if ( !sidebarTarget || !Array('A', 'BUTTON').includes(target.nodeName) ) {
            return;
        }

        e.preventDefault();

        const sidebarElm = document.getElementById( `sidebar-${sidebarTarget}` );

        if ( ! sidebarElm ) {
            console.debug( `Sidebar element: '${sidebarTarget}' not found.` );
            return;
        }

        // Open the sidebar
        // console.debug( `Open sidebar: '${sidebarTarget}'`, { sidebarElm } );
        target.blur();
        sidebarElm.showModal();
    });

    // Init sidebar elements
    const sidebarElms = document.querySelectorAll( 'dialog.sidebar' );

    sidebarElms.forEach( (sidebar) => {
        const wrapper = sidebar.querySelector( '.sidebar__wrapper' );
        const btnClose = sidebar.querySelector( '.sidebar__close' );

        const handleClosing = () => {
            if ( ! sidebar.hasAttribute( 'animated' ) ) {
                sidebar.close();
                return;
            }

            sidebar.setAttribute( 'closing', '' );

            sidebar.addEventListener( 'animationend', (e) => {
                sidebar.close();
            }, { once: true } );
        }

        // Handle click on backdrop or close button
        sidebar.addEventListener( 'click', (e) => {
            if ( ! wrapper.contains( e.target ) || btnClose.contains( e.target ) ) {
                handleClosing();
            }
        } );

        // Prevent closing with escape
        if ( sidebar.hasAttribute( 'no-esc-close' ) ) {
            // https://stackoverflow.com/a/79093934
            sidebar.addEventListener( 'keydown' , (e) => {
                if ( e.key === 'Escape' ) {
                    e.preventDefault();
                }
            });
        }

        // Handle sidebar cancel event
        sidebar.addEventListener( 'cancel', (e) => {
            e.preventDefault();
            handleClosing();
        });

        // Handle sidebar close event
        sidebar.addEventListener( 'close', (e) => {
            sidebar.removeAttribute( 'closing' );
        } );
    } );

})();
